import Vue from "vue";
import App from "./App.vue";
import { start } from "qiankun";
import DOMPurify from "dompurify";

function setSafeHtml(el, value) {
  el.innerHTML = DOMPurify.sanitize(value == null ? "" : String(value), {
    ADD_ATTR: ["target"],
  });
}

Vue.directive("safe-html", {
  bind(el, binding) {
    setSafeHtml(el, binding.value);
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      setSafeHtml(el, binding.value);
    }
  },
});

// 拦截子应用中常用的 window.open(url, '_self')，将其转换为单页路由跳转，避免整个页面刷新
const originalWindowOpen = window.open;
window.open = function (url, target, features) {
  if (target === "_self" && url && typeof url === "string") {
    // 判断是否是同源路由跳转
    const isSameOrigin = !url.startsWith("http://") && !url.startsWith("https://") && !url.startsWith("//");
    const isSameHost = url.startsWith(window.location.origin);

    if (isSameOrigin || isSameHost) {
      let targetPath = url;
      if (isSameHost) {
        targetPath = url.replace(window.location.origin, "");
      }
      history.pushState(null, "", targetPath);
      // 触发 popstate 事件，让主应用和子应用的路由系统能感知到变化
      window.dispatchEvent(new PopStateEvent("popstate", { state: null }));
      return null;
    }
  }
  return originalWindowOpen.call(window, url, target, features);
};

// ---------------------------------------------
// 创建项目
// vue create my_project

// 安装依赖
// npm i vue-router@3 --save
// npm install axios --save
// npm i element-ui -S
// npm install marked highlight.js
// ---------------------------------------------

// 引入vue-router --------------------
import VueRouter from "vue-router";
import router from "./router/index.js";
Vue.use(VueRouter);
// ----------------------------------

// 引入 elementUI 插件 -------------------------
import Breadcrumb from "element-ui/lib/breadcrumb";
import BreadcrumbItem from "element-ui/lib/breadcrumb-item";
import Button from "element-ui/lib/button";
import Card from "element-ui/lib/card";
import Col from "element-ui/lib/col";
import Collapse from "element-ui/lib/collapse";
import CollapseItem from "element-ui/lib/collapse-item";
import Descriptions from "element-ui/lib/descriptions";
import DescriptionsItem from "element-ui/lib/descriptions-item";
import Dialog from "element-ui/lib/dialog";
import Dropdown from "element-ui/lib/dropdown";
import DropdownItem from "element-ui/lib/dropdown-item";
import DropdownMenu from "element-ui/lib/dropdown-menu";
import Empty from "element-ui/lib/empty";
import Form from "element-ui/lib/form";
import FormItem from "element-ui/lib/form-item";
import Input from "element-ui/lib/input";
import Loading from "element-ui/lib/loading";
import Message from "element-ui/lib/message";
import MessageBox from "element-ui/lib/message-box";
import Option from "element-ui/lib/option";
import Pagination from "element-ui/lib/pagination";
import Popover from "element-ui/lib/popover";
import Row from "element-ui/lib/row";
import Select from "element-ui/lib/select";
import Step from "element-ui/lib/step";
import Steps from "element-ui/lib/steps";
import TabPane from "element-ui/lib/tab-pane";
import Tabs from "element-ui/lib/tabs";
import Tag from "element-ui/lib/tag";
import Tooltip from "element-ui/lib/tooltip";
import Upload from "element-ui/lib/upload";
import "element-ui/lib/theme-chalk/index.css";
[
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  Col,
  Collapse,
  CollapseItem,
  Descriptions,
  DescriptionsItem,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Empty,
  Form,
  FormItem,
  Input,
  Option,
  Pagination,
  Popover,
  Row,
  Select,
  Step,
  Steps,
  TabPane,
  Tabs,
  Tag,
  Tooltip,
  Upload,
].forEach(component => Vue.use(component));
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
// --------------------------------------------

// 引入axios ---------------------------------------------------
import request from "./request/index_oauth";
Vue.prototype.$http = request;
// -------------------------------------------------------------

// 挂载全局变量 -----------------------------------
import { globalUrl } from "./config";
Vue.prototype.globalUrl = globalUrl;
// ----------------------------------------------

// 在 Vue2 中使用 marked 渲染代码时，默认只会将代码块转换为 <pre><code> 标签，不会自带语法高亮样式。要让代码块有样式 ----------------
// 需要 marked 解析 markdown，以及 highlight.js 实现语法高亮
// npm install marked highlight.js --save
// ---------------------------------------------------------------------------------------------------------------------------

// 引入全局样式 ------------------------------------------------
import "./assets/css/global.css"; // 新建这个文件存放字体样式
// import './assets/css/highlight/atom-one-dark.css'  // 新建这个文件存放字体样式
// import './assets/css/highlight/atom-one-light.css'  // 新建这个文件存放字体样式
// ------------------------------------------------------------

start({
  sandbox: {
    strictStyleIsolation: true,
  },
  fetch: (url, ...args) => {
    if (url.includes("hm.baidu.com")) {
      return new Promise(resolve => {
        resolve(new Response());
      });
    }
    return window.fetch(url, ...args);
  },
});

new Vue({
  router,
  render: h => h(App),
}).$mount("#app");
